'use strict';
import analytics from './analytics';
import countries from './countries';
import quickview from './quickview';
import minicart from './minicart';
import rating from './rating';
import searchplaceholder from './searchplaceholder';
import skiplinks from './redesign/skiplinks';
import tooltip from './tooltip';
import util from './util';
import validator from './validator';
import slick from './slick';
import tls from './tls';
import video from './video';
import header from './header';
import footerSelector from './footer-selector';
import newsletter from './newsletter';
import inputEntry from './input-entry';
import pressrelease from './pressrelease';
import shadedtool from './shaded-tool';
import currentLayout from './detect-layout';
import customModal from './modal';
import search from './pages/search';
import productTile from './product-tile';
import quiz from './quiz';
import consentTracking from './consentTracking';
import delayImage from './delay-image';
import vitalperfect from './vital-perfect';
import pdp from './pages/product-detail';
import bambuser from './bambuser/bambuser';
import login from './login';
import pageNotFound from './pages/pagenotfounderror';
import newsletterModule from './newsletter-module';
import selectmenu from './selectmenu';
import toasts from './toast-notify';
import appHelper from './app-helper';
import redesignCheckoutLogin from './redesign/checkoutlogin';
import redesignLogin from './redesign/login-redesign';
import inputField from './addressForm/input-field';
import recommendationsEinstein from './pages/product/recommendationsCarousel';
import contentSlots from './content-slots';
import homepageExplore from './homepageExplore';
import copyTextToClipboard from './copy-text-clipboard';
import backInStock from './pages/product/backInStock';
import collectionRange from './collection_range';
import adventCalendarBlock from './advent-calendar';
import dialogSDKInit from './pages/product/dialogSDK';
import jqueryExt from './jquery-ext';
import cookieprivacy from './cookieprivacy';
import campaign from './campaign';
import captcha from './captcha';
import searchsuggestRedesign from './redesign/searchsuggest';
import searchsuggestDefault from './searchsuggest';

// pages
import account from './pages/account';
import brandify from './brandify';
import cart from './pages/cart';
import checkout from './pages/checkout';
import compare from './pages/compare';
import product from './pages/product';
import registry from './pages/registry';
import orderconfirmation from './pages/order-confirm';
import tutorial from './pages/tutorial';
import storefront from './pages/storefront';
import wishlist from './pages/wishlist';
import storelocator from './pages/storelocator';
import checkorder from './pages/checkorder';
import content from './pages/content';
import promotionlanding from './pages/promotionlanding';

const searchsuggest = $('#suggestions-redesign-enabled').length > 0
    ? searchsuggestRedesign
    : searchsuggestDefault;

// Initilize detect layout
var checkLayout = currentLayout.init();

//if jQuery has not been loaded, load from google cdn
if (!window.jQuery) {
    var s = document.createElement('script');

    s.setAttribute('src', 'https://ajax.googleapis.com/ajax/libs/jquery/3.5.0/jquery.min.js');
    s.setAttribute('type', 'text/javascript');

    document.getElementsByTagName('head')[0].appendChild(s);
}

jqueryExt();
cookieprivacy();
consentTracking.init();
captcha();
//bind global events
util.bindGlobalEvents();

//initialize campaign form events
campaign.init();

function initializeEvents() {
    //add csrf for post ajax call
    util.updateWithCsrfInputAjax();	
 
    /**
	 * initialize search suggestions, pending the value of the site preference(enhancedSearchSuggestions)
	 * this will either init the legacy(false) or the beta versions(true) of the the search suggest feature.
	 * */
    var $searchContainer = $('.header-search-wrapper .search-inner');

    searchsuggest.init($searchContainer, Resources.SIMPLE_SEARCH);
    skiplinks.init();
    // add show/hide navigation elements
    $('.secondary-navigation .toggle').click(function () {
        $(this).toggleClass('expanded').next('ul').toggle();
    });

    // add generic toggle functionality
    $('.toggle').next('.toggle-content').hide();
    $('.toggle').click(function () {
        $(this).toggleClass('expanded').next('.toggle-content').toggle();
    });

    // subscribe email box
    var $subscribeEmail = $('.subscribe-email');

    if ($subscribeEmail.length > 0) {
        $subscribeEmail.focus(function () {
            var val = $(this.val());

            if (val.length > 0 && val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
                return; // do not animate when contains non-default value
            }

            $(this).animate({
                color: '#999999'
            }, 500, 'linear', function () {
                $(this).val('').css('color', '#333333');
            });
        }).blur(function () {
            var val = $.trim($(this.val()));

            if (val.length > 0) {
                return; // do not animate when contains value
            }

            $(this).val(Resources.SUBSCRIBE_EMAIL_DEFAULT)
                .css('color', '#999999')
                .animate({
                    color: '#333333'
                }, 500, 'linear');
        });
    }

    $('.js-quiz-modal,.tapable-on-mobile').on('click', function () {
        var quizModal = $('#quiz-modal'),
            quizLoader = quizModal.find('.ajax-loader'),
            quizContent = quizModal.find('.questions-content');

        quizLoader.show();
        quizContent.empty();

        $.ajax({
            url: Urls.quizModalUrl,
            success: function (response) {
                quizLoader.hide();
                quizContent.empty().html(response);
                quiz.bindQuizEvents();
                quiz.createStepsIndicators();
                quiz.registerPageView(quizContent);
            }
        });
    });

    $('.js-VPquiz-modal').on('click', function () {
        var vpquizModal = $('#quiz-modal'),
            vpquizLoader = vpquizModal.find('.ajax-loader'),
            vpquizContent = vpquizModal.find('.questions-content');		
        var camp_id = $('.js-VPquiz-modal').data('campaign-id') ? '?campaignId='+$('.js-VPquiz-modal').data('campaign-id') : '';

        vpquizLoader.show();
        vpquizContent.empty();

        $.ajax({
            url: Urls.quizVPModalUrl+camp_id,
            success: function (response) {
                vpquizLoader.hide();
                vpquizContent.empty().html(response);
                vitalperfect.vpbindQuizEvents();
            }
        });
    });

    if ($('.order-confirmation-details').length) {
        sessionStorage.removeItem('isGift');
        sessionStorage.removeItem('giftMessage');
    }

    var url = Urls.passwordReset;

    if ($('.reset-password-link').length) {
        if (location.protocol === 'https:') {
            url = Urls.securePasswordReset;
        }

        $('.reset-password-link').each(function () {
            $(this).find('a').attr('href', url);
        });
    }

    if ($('.user-recognized').length) {
        if (location.protocol === 'https:') {
            url = Urls.securePasswordReset;
        }

        $('.user-recognized').find('a').attr('href', url);
    }

    // checkout checkout minicart on right side event handling
    appHelper.addSummaryScrollbar();

    //Accordion
    $('.footer-static-links').on('click', '.accordion .accordion_title', function () {
        let $this = $(this);
        let $description = $this.next();
        let $sbCheckout = $('.sb-checkout');
        
        if (!$description.is(':visible')) {
            $('.accordion_description').slideUp(300);
            $('.open').removeClass('open');
        }
        
        $description.slideToggle(300);
        $this.toggleClass('open');
        
        if ($this.hasClass('open') && $sbCheckout.length) {
            $sbCheckout.find('.sb-container').scrollBox();
        }
    });
    $(document).ready(function () {
        if ($('.accordion .accordion_title').hasClass('open')) {
            if ($('.sb-checkout').length) {
                $('.sb-checkout .sb-container').scrollBox();
            }
        }
        //To set header search icon alignment when Marketing site enabled
        if (!$('.minicart-link').length) {
            $('.courtesy-nav').css('margin-right', '0');
        }

        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
          $('body').addClass('safari');
        }

        if ($('.minicart-promotion').find('div').length == 0) {
            $('.cart-insert-promo').addClass('promoabsent');
        }
        if ($('.cart-insert-promo').find('div').length == 0 && $('.minicart-promotion').find('div').length == 0) {
            $('.cart-border').addClass('emptypromo');
        }
    });

    //Hero Carousel Chevron animation
    $('.hero-chevron .chevron-icon').click(function(e){
        var targetHeight= $('.top-hero-section').height();
        if (checkLayout == 'desktop') {
            $('html, body, .content').animate({scrollTop: targetHeight}, 1500);
        } else {
            $('html, body, .content').animate({scrollTop: targetHeight - 25}, 1500);
        }
			
        e.preventDefault();
    });

    //Tips and Tutorial slider
    appHelper.tipsAndTutorialSlider();
	
    // For Page Designer Vertical Carousel layout component
   	appHelper.pdVerticalCarousel();
}

/**
 * @private
 * @function
 * @description Screen Resize Handler.
 */
function screenResizeHandler() {
    $(window).on('resize orientationchange', function () {
        selectmenu.selectMenuSingleIntance();
        appHelper.updateSigleTileContentHeight();
        appHelper.aosInitialize();

        // Initilize detect layout on Resize
        checkLayout = currentLayout.init();
        if (checkLayout == 'desktop') {
            $('.main-nav').removeAttr('style');	
        } 

        if ($('#social-media-post-detail-modal').length) {
            $('#social-media-post-detail-modal').find('.modal-close').trigger('click');
        }
        //Check if Ipad and close megamenu is open
        if (navigator.userAgent.match(/iPad/i) !== null && window.matchMedia('(orientation: landscape)').matches) {
            if ($('ul.level-1 > li.has-sub-menu').hasClass('hover')) {
                $('.nav-close .close-icon').trigger('click');
            }
            if ($('.nav-open').length > 0) {
                $('html').removeClass('nav-open');
                $('.overlay').remove();
            }
        }

        // to fire search click when following condition fulfill 
        if(navigator.userAgent.match(/iPad/i) !== null && $('html').hasClass('sticky-header-search')) {
            $('.js-search-link').trigger('click');
        }

        if($(window).width() < 768){
            appHelper.crossNavBarHandler();
        }
        appHelper.crossNavAccessibilityHandling();
    });
}

/**
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
function initializeDom() {
    // add class to html for css targeting
    $('html').addClass('js');
    // Touch screen detection
    if ('ontouchstart' in window || 'ontouch' in window) {
        $('body').addClass('touch');
    }

    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $('html').addClass('infinite-scroll');
    }

    // initialize material input events
    inputField.init();

    //Initialize custom select
    selectmenu.selectMenu()

    // load js specific styles
    util.limitCharacters();	

    screenResizeHandler();

    recommendationsEinstein.init();
    util.paraEndWithThreeDots($('.mini-cart-product .mini-cart-name a'), 31, 26);
    util.paraEndWithThreeDots($('.regimenzone .product-brand-name-block .product-name'), 40, 31);
    util.ellipsisOnLongText($('.product-tile .product-brand-name-block .product-name'));

}

const pages = {
    account,
    brandify,
    cart,
    checkout,
    compare,
    product,
    registry,
    orderconfirmation,
    search,
    tutorial,
    storefront,
    wishlist,
    storelocator,
    checkorder,
    content,
    promotionlanding,
    quiz // consultation
};

var app = {
    init: function () {
        if (document.cookie.length === 0) {
            $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
        }
        initializeDom();
        initializeEvents();
        appHelper.resetFooterError();
        appHelper.searchMenuEvent();
        appHelper.backToTopHandler();
        appHelper.checkScrolledDown();
        // init specific global components
        analytics.init();
        countries.init();
        tooltip.init();
        minicart.init();
        validator.init();
        rating.init();
        slick.init();
        searchplaceholder.init();
        header.init();
        video.init();
        login.init();
        footerSelector.init();
        collectionRange.init();
        newsletter.newsletterHeader();
        newsletter.isNewsletterEnabled();
        inputEntry.init();
        $('.pt_pagedesigner').length && newsletter.pdNewsletterComponent();
        newsletterModule.init();
        appHelper.playVideoHandler();
        pressrelease.init();
        shadedtool.init();
        appHelper.updateSigleTileContentHeight();
        customModal.modal();
        search.viewMore();
        productTile.initCarouselSwatches();
        bambuser.init();
        video.initialize();
        delayImage.showDelayedImages();
        pdp.init();
        pageNotFound.init();
        redesignCheckoutLogin.init();
        homepageExplore.init();
        dialogSDKInit();
        if($(window).width() < 768){
            appHelper.crossNavBarHandler();
        }
        appHelper.crossNavAccessibilityHandling();
        selectmenu.countrySelectDropdown();
        selectmenu.selectMenuRefresh();
        selectmenu.selectMenuInDevice();
        appHelper.initPageSpecificModule(pages);
        copyTextToClipboard.init();
        adventCalendarBlock.init();
        // Check TLS status if indicated by site preference
        if (SitePreferences.CHECK_TLS === true) {
            tls.getUserAgent();
        }

        appHelper.defendAndRegenerate();
        appHelper.aosInitialize();
        if(SitePreferences.ENABLE_LOGIN_REDESIGN){
            redesignLogin.init();
        }
        contentSlots.init();
        backInStock.init();
    }
};

// to append country flag in jquery-ui widget
selectmenu.selectMenuWithCountryFlag();

//general extension functions
(function () {
    String.format = util.generalExtension;
})();

copyTextToClipboard.init();
// initialize the app when document.ready
$(function() {
    app.init();
    copyTextToClipboard.init();
    $('#login-wrapper-new .input-text.firstname, #login-wrapper-new .input-text.lastname, #login-wrapper-new .user-pass input').removeClass('error');
    util.scrollToError($('html, body'), $('.error-placement, input.error, .dropdownerror, .error').first(), 500);	
});

$(window).on('load', function () {
    appHelper.enableAddToCartCta();
    appHelper.loadHeroVideo();
});

$(window).on('load', function () {
    // Parse the URL parameters
    if (window.location.search) {
        const urlParams = new URLSearchParams(window.location.search);

        // Check if 'forgotpassword' is present and set to 'true'
        if (urlParams.get('forgotpassword') === 'true') {
            // Call the loginShow() function
            $('#login-wrapper-new').addClass('forgot-password');
            $('.reset-account-part').removeClass('visually-hidden');
            $('#signin-link > a').trigger('click');
        }
        if (urlParams.get('passwordchanged') === 'true') {
            $('#signin-link > a').trigger('click');
        }
    }
    if (window.location.hash === "#reviews") {  // Check if hash is #reviews
        const target = $("#reviews");  // Select the #reviews section
        if (target.length) {
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) { 
                        $("html, body").stop();  // Stop scrolling when #reviews is visible
                        observer.disconnect();  // Stop observing once triggered
                    }
                });
            }, { rootMargin: "-20% 0px -50% 0px", threshold: 0 }); // Trigger when 50% of the #reviews section is visible
    
            observer.observe(target[0]); // Observe the #reviews section
    
            $("html, body").stop(true, true).animate({
                scrollTop: target.offset().top
            }, 1500);
        }
    }
});

$(window).on('scroll', function () {
    appHelper.defendAndRegenerate();
    appHelper.checkScrolledDown();
});

// expose global app obj for 3rd party integrations
window.app = {
    quickView: quickview,
    minicart: minicart,
    user: window.User,
    SCemailUrl: window.Urls.SCemailUrl,
    Product: {},
    recommendationsEinstein : recommendationsEinstein,
    tagmanager: analytics.tagmanager,
    gtmInternalPromotion: analytics.gtmInternalPromotion
};

// expose global saveURL to support legacy Composed integration
window.saveURL = window.Urls.saveConsultationURL;
// summary scroll bar global scope
window.addSummaryScrollbar = appHelper.addSummaryScrollbar;
window.scrollToTop = appHelper.scrollToTop;
